import React, { useEffect } from 'react';

const AutonomousContainer = ({ children, protocol, viewMode }) => {
    useEffect(() => {
        if (protocol === 'PC' && viewMode === 'double') {
            const originalPadding = document.body.style.padding;
            const originalMargin = document.body.style.margin;
            //Supprime le padding de base de la pagepour maxiomiser l'espace d'affichage en vue double
            document.body.style.padding = '0';
            document.body.style.margin = '0';

            return () => {
                //Remet le padding et la margin de base de la page quand le composant est démonté
                document.body.style.padding = originalPadding;
                document.body.style.margin = originalMargin;
            };
        }
    }, [protocol, viewMode]); 

    return (
        <div className="autonomous-layout row">
            {children}
        </div>
    );
};

export default AutonomousContainer;